// LICENSE_CODE ZON
'use strict';/*jslint ts:true, react: true*/
import React from 'react';
import {url2md5} from 'pub_config';
import cn from 'classnames';

export const Spinner = ({small, width}:{small?: boolean, width?: number})=><img
  src={url2md5('/www/util/pub/img/spinner'+(small ? '.gif' : '_big.png'))}
  className={cn('spinner', 'lazyload')} alt="spinner"
  style={width ? {width: `${width}px`} : {}}/>;
